export const APP_LOADING = "APP_LOADING";
export const USER_FAV = "USER_FAV";
export const USER_UN_FAV = "USER_UN_FAV";
export const GET_ACHIEVEMENTS = "GET_ACHIEVEMENTS";
export const LANGUAGE_PREFERRED = "LANGUAGE_PREFERRED";
export const LANGUAGE_DATA = "LANGUAGE_DATA";
export const LANGUAGE_LIST = "LANGUAGE_LIST";
export const LANGUAGE_CURRENT = "LANGUAGE_CURRENT";
export const DASHBOARD_ACTION_GET_NEW_DATA = "DASHBOARD_ACTION_GET_NEW_DATA";
export const LOGIN_HARD_BLOCKER = "LOGIN_HARD_BLOCKER";
export const SET_MOBILE_VIEW = "SET_MOBILE_VIEW";
export const HOVERED_ACTIVE_ITEM = "HOVERED_ACTIVE_ITEM";
export const MAIN_CAROUSEL_DATA = "MAIN_CAROUSEL_DATA";

//Login and Sign Up
export const SIGN_UP_REQUEST = "SIGN_UP_REQUEST";
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const EMAIL_VERIFICATION_REQUEST = "EMAIL_VERIFICATION_REQUEST";
export const RESEND_VERIFICATION_REQUEST = "RESEND_VERIFICATION_REQUEST";

//Categories
export const CATEGORIES_READ_REQUEST = "CATEGORIES_READ_REQUEST";
export const CATEGORIES_TESTIMONY_SAVE_REQUEST = "CATEGORIES_TESTIMONY_SAVE_REQUEST";
export const CATEGORIES_TESTIMONY_UPDATE_REQUEST = "CATEGORIES_TESTIMONY_UPDATE_REQUEST";
export const CATEGORIES_TESTIMONY_DELETE_REQUEST = "CATEGORIES_TESTIMONY_DELETE_REQUEST";
export const READ_LAYOUTS_REQUEST = "READ_LAYOUTS_REQUEST";

//Home
export const SET_USER_PROFILE_DETAILS = "SET_USER_PROFILE_DETAILS";
export const GET_PROFILE_REQUEST = "GET_PROFILE_REQUEST";
export const READ_LANGUAGE_REQUEST = "READ_LANGUAGE_REQUEST";
export const READ_FAV_REQUEST = "READ_FAV_REQUEST";
export const GET_LANGUAGE_LIST_REQUEST = "GET_LANGUAGE_LIST_REQUEST";
export const GET_PICK_WHERE_LEFT_REQUEST = "GET_PICK_WHERE_LEFT_REQUEST";
export const SAVE_PICK_WHERE_LEFT_REQUEST = "SAVE_PICK_WHERE_LEFT_REQUEST";
export const SAVE_USER_PROFILE_REQUEST = "SAVE_USER_PROFILE_REQUEST";
export const UPDATE_USER_PROFILE_REQUEST = "UPDATE_USER_PROFILE_REQUEST";
export const LAYOUT_HOME_SCREEN_REQUEST = "LAYOUT_HOME_SCREEN_REQUEST";
export const LAYOUT_MAIN_CAROUSEL_REQUEST = "LAYOUT_MAIN_CAROUSEL_REQUEST";
export const LAYOUT_TOP10_REQUEST = "LAYOUT_TOP10_REQUEST";
export const READ_VIDEO_REQUEST = "READ_VIDEO_REQUEST";
export const UPLOAD_ASSEST_REQUEST = "UPLOAD_ASSEST_REQUEST";
export const GET_PROMISE_OF_THE_DAY_REQUEST = "GET_PROMISE_OF_THE_DAY_REQUEST";
export const GET_PROMISE_REQUEST = "GET_PROMISE_REQUEST";

export const CURRICULUM_READ_REQUEST = "CURRICULUM_READ_REQUEST";
export const CURRICULUM_HOME_READ_REQUEST = "CURRICULUM_HOME_READ_REQUEST";

export const SAVE_SUPPORT_REQUEST = "SAVE_SUPPORT_REQUEST";
export const SAVE_PRAYER_REQUEST = "SAVE_PRAYER_REQUEST";

//Testimonial
export const TESTIMONIAL_READ_REQUEST = "TESTIMONIAL_READ_REQUEST";
export const TESTIMONY_OF_THE_DAY_READ_REQUEST = "TESTIMONY_OF_THE_DAY_READ_REQUEST";
export const TESTIMONIAL_SAVE_REQUEST = "TESTIMONIAL_SAVE_REQUEST";
export const TESTIMONIAL_CATEGORY_SAVE_REQUEST = "TESTIMONIAL_CATEGORY_SAVE_REQUEST";
export const TESTIMONIAL_CATEGORY_READ_REQUEST = "TESTIMONIAL_CATEGORY_READ_REQUEST";
export const TESTIMONIAL_READ_TRENDING_REQUEST = "TESTIMONIAL_READ_TRENDING_REQUEST";
export const TESTIMONIAL_READ_LIKED_REQUEST = "TESTIMONIAL_READ_LIKED_REQUEST";
export const TESTIMONIAL_READ_BY_CATEGORY_REQUEST = "TESTIMONIAL_READ_BY_CATEGORY_REQUEST";
export const TESTIMONIAL_READ_INREVIEW_REQUEST = "TESTIMONIAL_READ_INREVIEW_REQUEST";
export const TESTIMONIAL_READ_APPROVED_REQUEST = "TESTIMONIAL_READ_APPROVED_REQUEST";
export const TESTIMONY_DELETE_REQUEST = "TESTIMONY_DELETE_REQUEST";

//Common
export const ADD_GLOBAL_VIDEOS = "ADD_GLOBAL_VIDEOS";
export const ADD_GLOBAL_TESTIMONIALS = "ADD_GLOBAL_TESTIMONIALS";
export const ADD_GLOBAL_CURRICULUM = "ADD_GLOBAL_CURRICULUM";
export const ADD_GLOBAL_CATEGORY = "ADD_GLOBAL_CATEGORY";
export const SET_GLOBAL_VIDEOS = "SET_GLOBAL_VIDEOS";
export const SET_GLOBAL_TESTIMONIALS = "SET_GLOBAL_TESTIMONIALS";
export const SET_GLOBAL_CURRICULUM = "SET_GLOBAL_CURRICULUM";
export const SET_GLOBAL_CATEGORY = "SET_GLOBAL_CATEGORY";
export const ADD_GLOBAL_JOURNALS = "ADD_GLOBAL_JOURNALS";
export const SHOW_NAVIGATION_ALERT = "SHOW_NAVIGATION_ALERT";

//Bible
export const SET_BIBLE_VERSION = "SET_BIBLE_VERSION";
export const SET_BIBLE_COUNTRY_LANGUAGES = "SET_BIBLE_COUNTRY_LANGUAGES";
export const SET_BIBLE_LANGUAGE = "SET_BIBLE_LANGUAGE";
export const SET_VERSION_DETAILS = "SET_VERSION_DETAILS";
export const SET_BIBLE_PARALLEL_MODE = "SET_BIBLE_PARALLEL_MODE";
export const SET_BOOK_CHAPTER_DETAILS = "SET_BOOK_CHAPTER_DETAILS";
export const SET_BOOK_CHAPTER_DETAILS_LOADING = "SET_BOOK_CHAPTER_DETAILS_LOADING";
export const SET_PARALLEL_VERSION_DETAILS = "SET_PARALLEL_VERSION_DETAILS";
export const SET_PARALLEL_BOOK_CHAPTER_DETAILS = "SET_PARALLEL_BOOK_CHAPTER_DETAILS";
export const SET_PARALLEL_BOOK_CHAPTER_DETAILS_LOADING =
  "SET_PARALLEL_BOOK_CHAPTER_DETAILS_LOADING";
export const SET_USER_JOURNALS = "SET_USER_JOURNALS";
export const SET_ACTIVE_SEARCH_TAB = "SET_ACTIVE_SEARCH_TAB";
export const SET_ACTIVE_PARALLEL_SEARCH_TAB = "SET_ACTIVE_PARALLEL_SEARCH_TAB";
export const SET_ALL_BIBLE_LANGUAGES = "SET_ALL_BIBLE_LANGUAGES";
export const SET_ALL_BIBLE_VERSIONS = "SET_ALL_BIBLE_VERSIONS";

export const GET_VERSION_BOOKS_REQUEST = "GET_VERSION_BOOKS_REQUEST";
export const GET_BIBLE_VERSIONS_REQUEST = "GET_BIBLE_VERSIONS_REQUEST";
export const GET_BIBLE_LANGUAGES_REQUEST = "GET_BIBLE_LANGUAGES_REQUEST";
export const GET_BIBLE_COUNTRY_LANGUAGES_REQUEST = "GET_BIBLE_COUNTRY_LANGUAGES_REQUEST";
export const GET_BIBLE_CHAPTER_DETAILS = "GET_BIBLE_CHAPTER_DETAILS";
export const GET_BIBLE_SEARCH = "GET_BIBLE_SEARCH";
export const GET_BIBLE_RESOURCE_KEY = "GET_BIBLE_RESOURCE_KEY";
export const GET_USER_JOURNALS = "GET_USER_JOURNALS";
export const DELETE_USER_JOURNALS = "DELETE_USER_JOURNALS";
export const GET_VERSE_DETAILS = "GET_VERSE_DETAILS";
export const SAVE_VERSE_COLOR = "SAVE_VERSE_COLOR";
export const UPDATE_VERSE_COLOR = "UPDATE_VERSE_COLOR";
export const DELETE_VERSE_COLOR = "DELETE_VERSE_COLOR";
export const GET_VERSE_COLOR = "GET_VERSE_COLOR";
export const GET_CHAPTER_VIDEOS = "GET_CHAPTER_VIDEOS";
export const GET_CHAPTER_JOURNALS = "GET_CHAPTER_JOURNALS";
export const GET_JOURNALS = "GET_JOURNALS";
export const UPDATE_USER_STREAK = "UPDATE_USER_STREAK";
export const GET_USER_STREAK_SUMMARY = "GET_USER_STREAK_SUMMARY";
export const GET_JOURNAL_SPEAKERS = "GET_JOURNAL_SPEAKERS";
export const GET_JOURNALS_BY_SPEAKER = "GET_JOURNALS_BY_SPEAKER";
export const GET_JOURNALS_BY_CATEGORY = "GET_JOURNALS_BY_CATEGORY";
export const GET_BIBLE_SUMMARY = "GET_BIBLE_SUMMARY";

export const SAVE_JOURNAL_REQUEST = "SAVE_JOURNAL_REQUEST";
export const UPDATE_JOURNAL_REQUEST = "UPDATE_JOURNAL_REQUEST";
export const DELETE_JOURNAL_REQUEST = "DELETE_JOURNAL_REQUEST";

export const ADD_JOURNAL_NOTE_REQUEST = "ADD_JOURNAL_NOTE_REQUEST";
export const UPDATE_JOURNAL_NOTE_REQUEST = "UPDATE_JOURNAL_NOTE_REQUEST";
export const DELETE_JOURNAL_NOTE_REQUEST = "DELETE_JOURNAL_NOTE_REQUEST";

export const ADD_JOURNAL_NOTE_ITEM_REQUEST = "ADD_JOURNAL_NOTE_ITEM_REQUEST";
export const UPDATE_JOURNAL_NOTE_ITEM_REQUEST = "UPDATE_JOURNAL_NOTE_ITEM_REQUEST";
export const DELETE_JOURNAL_NOTE_ITEM_REQUEST = "DELETE_JOURNAL_NOTE_ITEM_REQUEST";

export const GLOBAL_BIBLE_SEARCH = "GLOBAL_BIBLE_SEARCH";
export const GLOBAL_VIDEO_SEARCH = "GLOBAL_VIDEO_SEARCH";
export const GLOBAL_TESTIMONY_SEARCH = "GLOBAL_TESTIMONY_SEARCH";
export const GLOBAL_PROMISE_SEARCH = "GLOBAL_PROMISE_SEARCH";
export const GLOBAL_JOURNAL_SEARCH = "GLOBAL_JOURNAL_SEARCH";
export const GLOBAL_CURRICULUM_SEARCH = "GLOBAL_CURRICULUM_SEARCH";
export const GLOBAL_CATEGORIES_SEARCH = "GLOBAL_CATEGORIES_SEARCH";

// Bible search
export const SET_GLOBAL_BIBLE_SEARCH_RESULTS = "SET_GLOBAL_BIBLE_SEARCH_RESULTS";
export const ADD_GLOBAL_BIBLE_SEARCH_RESULTS = "ADD_GLOBAL_BIBLE_SEARCH_RESULTS";

// Video search
export const SET_GLOBAL_VIDEO_SEARCH_RESULTS = "SET_GLOBAL_VIDEO_SEARCH_RESULTS";
export const ADD_GLOBAL_VIDEO_SEARCH_RESULTS = "ADD_GLOBAL_VIDEO_SEARCH_RESULTS";

// Testimony search
export const SET_GLOBAL_TESTIMONY_SEARCH_RESULTS = "SET_GLOBAL_TESTIMONY_SEARCH_RESULTS";
export const ADD_GLOBAL_TESTIMONY_SEARCH_RESULTS = "ADD_GLOBAL_TESTIMONY_SEARCH_RESULTS";

// Promise search
export const SET_GLOBAL_PROMISE_SEARCH_RESULTS = "SET_GLOBAL_PROMISE_SEARCH_RESULTS";
export const ADD_GLOBAL_PROMISE_SEARCH_RESULTS = "ADD_GLOBAL_PROMISE_SEARCH_RESULTS";

// Journal search
export const SET_GLOBAL_JOURNAL_SEARCH_RESULTS = "SET_GLOBAL_JOURNAL_SEARCH_RESULTS";
export const ADD_GLOBAL_JOURNAL_SEARCH_RESULTS = "ADD_GLOBAL_JOURNAL_SEARCH_RESULTS";

// Curriculum search
export const SET_GLOBAL_CURRICULUM_SEARCH_RESULTS = "SET_GLOBAL_CURRICULUM_SEARCH_RESULTS";
export const ADD_GLOBAL_CURRICULUM_SEARCH_RESULTS = "ADD_GLOBAL_CURRICULUM_SEARCH_RESULTS";

// Categories search
export const SET_GLOBAL_CATEGORIES_SEARCH_RESULTS = "SET_GLOBAL_CATEGORIES_SEARCH_RESULTS";
export const ADD_GLOBAL_CATEGORIES_SEARCH_RESULTS = "ADD_GLOBAL_CATEGORIES_SEARCH_RESULTS";


//Church
export const CHURCHES_READ_REQUEST = "CHURCHES_READ_REQUEST";
export const CHURCHES_READ_SUCCESS = "CHURCHES_READ_SUCCESS";
export const CHURCHES_READ_FAIL = "CHURCHES_READ_FAIL";
export const LIKE_CHURCH_REQUEST = "LIKE_CHURCH_REQUEST";
export const LIKE_CHURCH_SUCCESS = "LIKE_CHURCH_SUCCESS";
export const LIKE_CHURCH_FAIL = "LIKE_CHURCH_FAIL";
export const SAVE_SERVICE_VOLUNTEER_REQUEST = "SAVE_SERVICE_VOLUNTEER_REQUEST";
export const SAVE_SERVICE_VOLUNTEER_SUCCESS = "SAVE_SERVICE_VOLUNTEER_SUCCESS";
export const SAVE_SERVICE_VOLUNTEER_FAIL = "SAVE_SERVICE_VOLUNTEER_FAIL";


//Users
// In ActionTypes.js

export const AVAILABLE_USERS_REQUEST = "AVAILABLE_USERS_REQUEST";
export const AVAILABLE_USERS_SUCCESS = "AVAILABLE_USERS_SUCCESS";
export const AVAILABLE_USERS_FAIL = "AVAILABLE_USERS_FAIL";

export const SAVE_USER_CIRCLE_REQUEST = "SAVE_USER_CIRCLE_REQUEST";
export const SAVE_USER_CIRCLE_SUCCESS = "SAVE_USER_CIRCLE_SUCCESS";
export const SAVE_USER_CIRCLE_FAIL = "SAVE_USER_CIRCLE_FAIL";

// ActionTypes.js
export const MY_CIRCLE_REQUESTS_REQUEST = "MY_CIRCLE_REQUESTS_REQUEST";
export const MY_CIRCLE_REQUESTS_SUCCESS = "MY_CIRCLE_REQUESTS_SUCCESS";
export const MY_CIRCLE_REQUESTS_FAIL = "MY_CIRCLE_REQUESTS_FAIL";

// ActionTypes.js
export const UPDATE_USER_CIRCLE_REQUEST = "UPDATE_USER_CIRCLE_REQUEST";
export const UPDATE_USER_CIRCLE_SUCCESS = "UPDATE_USER_CIRCLE_SUCCESS";
export const UPDATE_USER_CIRCLE_FAIL = "UPDATE_USER_CIRCLE_FAIL";
// ActionTypes.js
export const MY_CIRCLE_LIST_REQUEST = "MY_CIRCLE_LIST_REQUEST";
export const MY_CIRCLE_LIST_SUCCESS = "MY_CIRCLE_LIST_SUCCESS";
export const MY_CIRCLE_LIST_FAIL = "MY_CIRCLE_LIST_FAIL";

//Plan
// ActionTypes.js

export const SAVE_PLAN_REQUEST = "SAVE_PLAN_REQUEST";
export const SAVE_PLAN_SUCCESS = "SAVE_PLAN_SUCCESS";
export const SAVE_PLAN_FAIL = "SAVE_PLAN_FAIL";

export const UPDATE_PLAN_REQUEST = "UPDATE_PLAN_REQUEST";
export const UPDATE_PLAN_SUCCESS = "UPDATE_PLAN_SUCCESS";
export const UPDATE_PLAN_FAIL = "UPDATE_PLAN_FAIL";

export const READ_PLAN_REQUEST = "READ_PLAN_REQUEST";
export const READ_PLAN_SUCCESS = "READ_PLAN_SUCCESS";
export const READ_PLAN_FAIL = "READ_PLAN_FAIL";

export const SAVE_DAY_PLAN_REQUEST = "SAVE_DAY_PLAN_REQUEST";
export const SAVE_DAY_PLAN_SUCCESS = "SAVE_DAY_PLAN_SUCCESS";
export const SAVE_DAY_PLAN_FAIL = "SAVE_DAY_PLAN_FAIL";

export const UPDATE_DAY_PLAN_REQUEST = "UPDATE_DAY_PLAN_REQUEST";
export const UPDATE_DAY_PLAN_SUCCESS = "UPDATE_DAY_PLAN_SUCCESS";
export const UPDATE_DAY_PLAN_FAIL = "UPDATE_DAY_PLAN_FAIL";

export const UPDATE_DAY_PLAN_PROGRESS_REQUEST = "UPDATE_DAY_PLAN_PROGRESS_REQUEST";
export const UPDATE_DAY_PLAN_PROGRESS_SUCCESS = "UPDATE_DAY_PLAN_PROGRESS_SUCCESS";
export const UPDATE_DAY_PLAN_PROGRESS_FAIL = "UPDATE_DAY_PLAN_PROGRESS_FAIL";

export const DELETE_DAY_PLAN_REQUEST = "DELETE_DAY_PLAN_REQUEST";
export const DELETE_DAY_PLAN_SUCCESS = "DELETE_DAY_PLAN_SUCCESS";
export const DELETE_DAY_PLAN_FAIL = "DELETE_DAY_PLAN_FAIL";

export const SAVE_DAY_PLAN_DETAILS_REQUEST = "SAVE_DAY_PLAN_DETAILS_REQUEST";
export const SAVE_DAY_PLAN_DETAILS_SUCCESS = "SAVE_DAY_PLAN_DETAILS_SUCCESS";
export const SAVE_DAY_PLAN_DETAILS_FAIL = "SAVE_DAY_PLAN_DETAILS_FAIL";

export const UPDATE_DAY_PLAN_DETAILS_REQUEST = "UPDATE_DAY_PLAN_DETAILS_REQUEST";
export const UPDATE_DAY_PLAN_DETAILS_SUCCESS = "UPDATE_DAY_PLAN_DETAILS_SUCCESS";
export const UPDATE_DAY_PLAN_DETAILS_FAIL = "UPDATE_DAY_PLAN_DETAILS_FAIL";

export const DELETE_DAY_PLAN_DETAILS_REQUEST = "DELETE_DAY_PLAN_DETAILS_REQUEST";
export const DELETE_DAY_PLAN_DETAILS_SUCCESS = "DELETE_DAY_PLAN_DETAILS_SUCCESS";
export const DELETE_DAY_PLAN_DETAILS_FAIL = "DELETE_DAY_PLAN_DETAILS_FAIL";

export const CREATE_YOUTUBE_PLAN_REQUEST = "CREATE_YOUTUBE_PLAN_REQUEST";
export const CREATE_YOUTUBE_PLAN_SUCCESS = "CREATE_YOUTUBE_PLAN_SUCCESS";
export const CREATE_YOUTUBE_PLAN_FAIL = "CREATE_YOUTUBE_PLAN_FAIL";

export const READ_USER_PLANS_REQUEST = "READ_USER_PLANS_REQUEST";
export const READ_USER_PLANS_SUCCESS = "READ_USER_PLANS_SUCCESS";
export const READ_USER_PLANS_FAIL = "READ_USER_PLANS_FAIL";

export const READ_FOLLOWED_ENTITY_PLANS_REQUEST = "READ_FOLLOWED_ENTITY_PLANS_REQUEST";
export const READ_FOLLOWED_ENTITY_PLANS_SUCCESS = "READ_FOLLOWED_ENTITY_PLANS_SUCCESS";
export const READ_FOLLOWED_ENTITY_PLANS_FAIL = "READ_FOLLOWED_ENTITY_PLANS_FAIL";

export const READ_USER_SERMON_STUDY_JOBS_REQUEST = "READ_USER_SERMON_STUDY_JOBS_REQUEST";
export const READ_USER_SERMON_STUDY_JOBS_SUCCESS = "READ_USER_SERMON_STUDY_JOBS_SUCCESS";
export const READ_USER_SERMON_STUDY_JOBS_FAIL = "READ_USER_SERMON_STUDY_JOBS_FAIL";

export const RESET_SERMON_STUDY_RETRY_REQUEST = "RESET_SERMON_STUDY_RETRY_REQUEST";
export const RESET_SERMON_STUDY_RETRY_SUCCESS = "RESET_SERMON_STUDY_RETRY_SUCCESS";
export const RESET_SERMON_STUDY_RETRY_FAIL = "RESET_SERMON_STUDY_RETRY_FAIL";

export const READ_TWG_PLANS_REQUEST = "READ_TWG_PLANS_REQUEST";
export const READ_TWG_PLANS_SUCCESS = "READ_TWG_PLANS_SUCCESS";
export const READ_TWG_PLANS_FAIL = "READ_TWG_PLANS_FAIL";

//groups
// store/ActionTypes.js
export const SAVE_GROUP_REQUEST = "SAVE_GROUP_REQUEST";
export const SAVE_GROUP_SUCCESS = "SAVE_GROUP_SUCCESS";
export const SAVE_GROUP_FAIL = "SAVE_GROUP_FAIL";

export const SAVE_GROUP_MEMBERS_REQUEST = "SAVE_GROUP_MEMBERS_REQUEST";
export const SAVE_GROUP_MEMBERS_SUCCESS = "SAVE_GROUP_MEMBERS_SUCCESS";
export const SAVE_GROUP_MEMBERS_FAIL = "SAVE_GROUP_MEMBERS_FAIL";

export const SAVE_GROUP_BIBLEPLAN_REQUEST = "SAVE_GROUP_BIBLEPLAN_REQUEST";
export const SAVE_GROUP_BIBLEPLAN_SUCCESS = "SAVE_GROUP_BIBLEPLAN_SUCCESS";
export const SAVE_GROUP_BIBLEPLAN_FAIL = "SAVE_GROUP_BIBLEPLAN_FAIL";
// Devotionals
export const SAVE_DEVOTIONAL_REQUEST = "SAVE_DEVOTIONAL_REQUEST";
export const SAVE_DEVOTIONAL_SUCCESS = "SAVE_DEVOTIONAL_SUCCESS";
export const SAVE_DEVOTIONAL_FAIL = "SAVE_DEVOTIONAL_FAIL";

export const SAVE_DEVOTIONAL_VIDEO_REQUEST = "SAVE_DEVOTIONAL_VIDEO_REQUEST";
export const SAVE_DEVOTIONAL_VIDEO_SUCCESS = "SAVE_DEVOTIONAL_VIDEO_SUCCESS";
export const SAVE_DEVOTIONAL_VIDEO_FAIL = "SAVE_DEVOTIONAL_VIDEO_FAIL";

export const SAVE_DEVOTIONAL_JOURNAL_REQUEST = "SAVE_DEVOTIONAL_JOURNAL_REQUEST";
export const SAVE_DEVOTIONAL_JOURNAL_SUCCESS = "SAVE_DEVOTIONAL_JOURNAL_SUCCESS";
export const SAVE_DEVOTIONAL_JOURNAL_FAIL = "SAVE_DEVOTIONAL_JOURNAL_FAIL";

export const SAVE_DEVOTIONAL_TESTIMONY_REQUEST = "SAVE_DEVOTIONAL_TESTIMONY_REQUEST";
export const SAVE_DEVOTIONAL_TESTIMONY_SUCCESS = "SAVE_DEVOTIONAL_TESTIMONY_SUCCESS";
export const SAVE_DEVOTIONAL_TESTIMONY_FAIL = "SAVE_DEVOTIONAL_TESTIMONY_FAIL";

export const SAVE_DEVOTIONAL_VERSE_REQUEST = "SAVE_DEVOTIONAL_VERSE_REQUEST";
export const SAVE_DEVOTIONAL_VERSE_SUCCESS = "SAVE_DEVOTIONAL_VERSE_SUCCESS";
export const SAVE_DEVOTIONAL_VERSE_FAIL = "SAVE_DEVOTIONAL_VERSE_FAIL";
// In ActionTypes.js
export const READ_DEVOTIONALS_REQUEST = 'READ_DEVOTIONALS_REQUEST';
export const READ_DEVOTIONALS_SUCCESS = 'READ_DEVOTIONALS_SUCCESS';
export const READ_DEVOTIONALS_FAIL = 'READ_DEVOTIONALS_FAIL';

// In ActionTypes.js
export const SAVE_GROUP_DEVOTIONALS_REQUEST = 'SAVE_GROUP_DEVOTIONALS_REQUEST';
export const SAVE_GROUP_DEVOTIONALS_SUCCESS = 'SAVE_GROUP_DEVOTIONALS_SUCCESS';
export const SAVE_GROUP_DEVOTIONALS_FAIL = 'SAVE_GROUP_DEVOTIONALS_FAIL';
// In ActionTypes.js
export const SAVE_GROUP_JOURNALS_REQUEST = 'SAVE_GROUP_JOURNALS_REQUEST';
export const SAVE_GROUP_JOURNALS_SUCCESS = 'SAVE_GROUP_JOURNALS_SUCCESS';
export const SAVE_GROUP_JOURNALS_FAIL = 'SAVE_GROUP_JOURNALS_FAIL';

export const SAVE_GROUP_VIDEOS_REQUEST = 'SAVE_GROUP_VIDEOS_REQUEST';
export const SAVE_GROUP_VIDEOS_SUCCESS = 'SAVE_GROUP_VIDEOS_SUCCESS';
export const SAVE_GROUP_VIDEOS_FAIL = 'SAVE_GROUP_VIDEOS_FAIL';

export const SAVE_GROUP_CURRICULUMS_REQUEST = 'SAVE_GROUP_CURRICULUMS_REQUEST';
export const SAVE_GROUP_CURRICULUMS_SUCCESS = 'SAVE_GROUP_CURRICULUMS_SUCCESS';
export const SAVE_GROUP_CURRICULUMS_FAIL = 'SAVE_GROUP_CURRICULUMS_FAIL';

export const SAVE_GROUP_TESTIMONIES_REQUEST = 'SAVE_GROUP_TESTIMONIES_REQUEST';
export const SAVE_GROUP_TESTIMONIES_SUCCESS = 'SAVE_GROUP_TESTIMONIES_SUCCESS';
export const SAVE_GROUP_TESTIMONIES_FAIL = 'SAVE_GROUP_TESTIMONIES_FAIL';
export const READ_MY_GROUPS_REQUEST = "READ_MY_GROUPS_REQUEST";
export const READ_MY_GROUPS_SUCCESS = "READ_MY_GROUPS_SUCCESS";
export const READ_MY_GROUPS_FAIL = "READ_MY_GROUPS_FAIL";

export const FEATURED_CHURCHES_READ_REQUEST = "FEATURED_CHURCHES_READ_REQUEST";
export const FEATURED_CHURCHES_READ_SUCCESS = "FEATURED_CHURCHES_READ_SUCCESS";
export const FEATURED_CHURCHES_READ_FAIL = "FEATURED_CHURCHES_READ_FAIL";

export const FAVOURITE_CHURCHES_READ_REQUEST = "FAVOURITE_CHURCHES_READ_REQUEST";
export const FAVOURITE_CHURCHES_READ_SUCCESS = "FAVOURITE_CHURCHES_READ_SUCCESS";
export const FAVOURITE_CHURCHES_READ_FAIL = "FAVOURITE_CHURCHES_READ_FAIL";

export const HOME_CHURCHES_READ_REQUEST = "HOME_CHURCHES_READ_REQUEST";
export const HOME_CHURCHES_READ_SUCCESS = "HOME_CHURCHES_READ_SUCCESS";
export const HOME_CHURCHES_READ_FAIL = "HOME_CHURCHES_READ_FAIL";

export const NEARBY_CHURCHES_READ_REQUEST = "NEARBY_CHURCHES_READ_REQUEST";
export const NEARBY_CHURCHES_READ_SUCCESS = "NEARBY_CHURCHES_READ_SUCCESS";
export const NEARBY_CHURCHES_READ_FAIL = "NEARBY_CHURCHES_READ_FAIL";


export const PRAYER_REQUEST_CREATE_REQUEST = "PRAYER_REQUEST_CREATE_REQUEST";
export const PRAYER_REQUEST_CREATE_SUCCESS = "PRAYER_REQUEST_CREATE_SUCCESS";
export const PRAYER_REQUEST_CREATE_FAIL = "PRAYER_REQUEST_CREATE_FAIL";
export const MY_PRAYER_REQUESTS_FETCH_REQUEST = "MY_PRAYER_REQUESTS_FETCH_REQUEST";
export const MY_PRAYER_REQUESTS_FETCH_SUCCESS = "MY_PRAYER_REQUESTS_FETCH_SUCCESS";
export const MY_PRAYER_REQUESTS_FETCH_FAIL = "MY_PRAYER_REQUESTS_FETCH_FAIL";
export const UNLIKE_CHURCH_REQUEST = "UNLIKE_CHURCH_REQUEST";
export const UNLIKE_CHURCH_SUCCESS = "UNLIKE_CHURCH_SUCCESS";
export const UNLIKE_CHURCH_FAIL = "UNLIKE_CHURCH_FAIL";

// Prayer Responses
export const PRAYER_RESPONSE_CREATE_REQUEST = "PRAYER_RESPONSE_CREATE_REQUEST";
export const PRAYER_RESPONSE_CREATE_SUCCESS = "PRAYER_RESPONSE_CREATE_SUCCESS";
export const PRAYER_RESPONSE_CREATE_FAIL = "PRAYER_RESPONSE_CREATE_FAIL";

export const PRAYER_RESPONSE_UPDATE_REQUEST = "PRAYER_RESPONSE_UPDATE_REQUEST";
export const PRAYER_RESPONSE_UPDATE_SUCCESS = "PRAYER_RESPONSE_UPDATE_SUCCESS";
export const PRAYER_RESPONSE_UPDATE_FAIL = "PRAYER_RESPONSE_UPDATE_FAIL";

export const PRAYER_RESPONSE_DELETE_REQUEST = "PRAYER_RESPONSE_DELETE_REQUEST";
export const PRAYER_RESPONSE_DELETE_SUCCESS = "PRAYER_RESPONSE_DELETE_SUCCESS";
export const PRAYER_RESPONSE_DELETE_FAIL = "PRAYER_RESPONSE_DELETE_FAIL";

export const PRAYER_RESPONSE_READ_REQUEST = "PRAYER_RESPONSE_READ_REQUEST";
export const PRAYER_RESPONSE_READ_SUCCESS = "PRAYER_RESPONSE_READ_SUCCESS";
export const PRAYER_RESPONSE_READ_FAIL = "PRAYER_RESPONSE_READ_FAIL";

// ActionTypes.js
export const MY_PRAYERS_LIST_FETCH_REQUEST = "MY_PRAYERS_LIST_FETCH_REQUEST";
export const MY_PRAYERS_LIST_FETCH_SUCCESS = "MY_PRAYERS_LIST_FETCH_SUCCESS";
export const MY_PRAYERS_LIST_FETCH_FAIL = "MY_PRAYERS_LIST_FETCH_FAIL";

export const CHURCH_FOLLOWERS_PRAYERS_FETCH_REQUEST =
  "CHURCH_FOLLOWERS_PRAYERS_FETCH_REQUEST";
export const CHURCH_FOLLOWERS_PRAYERS_FETCH_SUCCESS =
  "CHURCH_FOLLOWERS_PRAYERS_FETCH_SUCCESS";
export const CHURCH_FOLLOWERS_PRAYERS_FETCH_FAIL =
  "CHURCH_FOLLOWERS_PRAYERS_FETCH_FAIL";

  // Channel followers prayers
export const CHANNEL_FOLLOWERS_PRAYERS_FETCH_REQUEST =
"CHANNEL_FOLLOWERS_PRAYERS_FETCH_REQUEST";
export const CHANNEL_FOLLOWERS_PRAYERS_FETCH_SUCCESS =
"CHANNEL_FOLLOWERS_PRAYERS_FETCH_SUCCESS";
export const CHANNEL_FOLLOWERS_PRAYERS_FETCH_FAIL =
"CHANNEL_FOLLOWERS_PRAYERS_FETCH_FAIL";

// Ministry followers prayers
export const MINISTRIES_FOLLOWERS_PRAYERS_FETCH_REQUEST =
"MINISTRIES_FOLLOWERS_PRAYERS_FETCH_REQUEST";
export const MINISTRIES_FOLLOWERS_PRAYERS_FETCH_SUCCESS =
"MINISTRIES_FOLLOWERS_PRAYERS_FETCH_SUCCESS";
export const MINISTRIES_FOLLOWERS_PRAYERS_FETCH_FAIL =
"MINISTRIES_FOLLOWERS_PRAYERS_FETCH_FAIL";

// Comment Action Types
export const COMMENT_CREATE_REQUEST = 'COMMENT_CREATE_REQUEST';
export const COMMENT_CREATE_SUCCESS = 'COMMENT_CREATE_SUCCESS';
export const COMMENT_CREATE_FAIL = 'COMMENT_CREATE_FAIL';

export const COMMENT_UPDATE_REQUEST = 'COMMENT_UPDATE_REQUEST';
export const COMMENT_UPDATE_SUCCESS = 'COMMENT_UPDATE_SUCCESS';
export const COMMENT_UPDATE_FAIL = 'COMMENT_UPDATE_FAIL';

export const COMMENT_DELETE_REQUEST = 'COMMENT_DELETE_REQUEST';
export const COMMENT_DELETE_SUCCESS = 'COMMENT_DELETE_SUCCESS';
export const COMMENT_DELETE_FAIL = 'COMMENT_DELETE_FAIL';

export const COMMENT_READ_REQUEST = 'COMMENT_READ_REQUEST';
export const COMMENT_READ_SUCCESS = 'COMMENT_READ_SUCCESS';
export const COMMENT_READ_FAIL = 'COMMENT_READ_FAIL';

export const COMMENT_TREE_REQUEST = 'COMMENT_TREE_REQUEST';
export const COMMENT_TREE_SUCCESS = 'COMMENT_TREE_SUCCESS';
export const COMMENT_TREE_FAIL = 'COMMENT_TREE_FAIL';

export const COMMENT_LIKE_SAVE_REQUEST = 'COMMENT_LIKE_SAVE_REQUEST';
export const COMMENT_LIKE_SAVE_SUCCESS = 'COMMENT_LIKE_SAVE_SUCCESS';
export const COMMENT_LIKE_SAVE_FAIL = 'COMMENT_LIKE_SAVE_FAIL';

export const COMMENT_LIKE_DELETE_REQUEST = 'COMMENT_LIKE_DELETE_REQUEST';
export const COMMENT_LIKE_DELETE_SUCCESS = 'COMMENT_LIKE_DELETE_SUCCESS';
export const COMMENT_LIKE_DELETE_FAIL = 'COMMENT_LIKE_DELETE_FAIL';
